import {
  EmptyStateError,
  EmptyStateLoading,
  lazyLoad,
} from 'src/core/common/components/LazyLoad';

export const TripDetailsPageLazy = lazyLoad({
  loader: async () => ({
    /* eslint-disable unicorn/no-await-expression-member */
    default: (
      await import(/* webpackChunkName: "TripDetails" */ './TripDetailsPage')
    ).TripDetailsPage,
    /* eslint-enable */
  }),
  loading: <EmptyStateLoading />,
  fallback: (props) => <EmptyStateError {...props} />,
});

